import { makePostRequest } from 'owa-ows-gateway';
import { PostUserPersistedFlightRequest } from './PostUserPersistedFlightRequest';

const POST_USERPERSISTED_FLIGHT_URL: string = 'ows/api/v1/PremiumFlight';

export async function postUserPersistedFlight(
    request: PostUserPersistedFlightRequest
): Promise<void> {
    return makePostRequest(POST_USERPERSISTED_FLIGHT_URL, request);
}
